import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import properties from '@/properties';
import Toasted from 'vue-toasted';
import VueScrollTo from 'vue-scrollto';
import VueModal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'

Vue.use(Toasted);
Vue.use(VueScrollTo);
Vue.use(VueGoogleMaps, {
  load: {
    key: properties.GOOGLE_API_KEY,
    libraries: properties.GOOGLE_LIBRARIES
  }
});

Vue.component('Modal', VueModal)



// WEBPACK FOOTER //
// ./src/externalVueModules.js